export default __webpack_public_path__ + "static/zara-d6430fc9fd02eba005c039c48d64a07a.png";